import phoneCountries from "../catalogs/phoneCountries";

export const getErrMsg = (error, fallback = "Algo salió mal") => {
  const raw =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message;

  if (!raw) return fallback;
  if (Array.isArray(raw)) return raw.join(", ");
  if (typeof raw === "object") return fallback;
  return String(raw);
};

export const norm = (v) => String(v ?? "").trim();
export const normBool = (v) => !!v;

export const shallowEqualByKeys = (a, b, keys) => {
  for (const k of keys) {
    const av = a?.[k];
    const bv = b?.[k];

    if (typeof av === "boolean" || typeof bv === "boolean") {
      if (normBool(av) !== normBool(bv)) return false;
      continue;
    }

    if (norm(av) !== norm(bv)) return false;
  }
  return true;
};

export const onlyDigits = (v) => String(v ?? "").replace(/\D+/g, "");

export const getPhoneMeta = (codigo_telefono) => {
  const code = norm(codigo_telefono) || "+502";
  return phoneCountries.find((c) => c.code === code) || phoneCountries[0];
};

export const validatePhone = ({ codigo_telefono, telefono }) => {
  const code = norm(codigo_telefono);
  const phone = onlyDigits(telefono);

  const hasAny = !!code || !!phone;
  if (!hasAny || (!code && !phone)) {
    return { ok: true, clean: { code: "", phone: "" } };
  }

  if (code && !phone) {
    return {
      ok: false,
      message: "Ingresa tu número de teléfono o borra el código de país.",
    };
  }

  if (!code && phone) {
    return {
      ok: false,
      message: "Selecciona un código de país para tu número de teléfono.",
    };
  }

  const meta = phoneCountries.find((c) => c.code === code);
  if (!meta) {
    return { ok: false, message: "Código de país seleccionado inválido." };
  }

  const len = phone.length;
  if (len < meta.minLength || len > meta.maxLength) {
    return {
      ok: false,
      message: `El número de teléfono para ${meta.country} debe tener ${meta.minLength}${
        meta.minLength === meta.maxLength ? "" : `–${meta.maxLength}`
      } dígitos.`,
    };
  }

  return { ok: true, clean: { code, phone } };
};

/** Validación de nombre de usuario (login); alineada con registro en backend. */
export const validateUsuario = (u) => {
  const s = norm(u);
  if (!s) {
    return { ok: false, message: "El usuario es requerido." };
  }
  if (s.length < 2 || s.length > 64) {
    return {
      ok: false,
      message: "El usuario debe tener entre 2 y 64 caracteres.",
    };
  }
  return { ok: true, clean: s };
};

